import {
    CircularProgress,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SortAsc from '../../assets/images/llantas/table/sort-asc.svg';
import SortDesc from '../../assets/images/llantas/table/sort-desc.svg';
import Sort from '../../assets/images/llantas/table/sort.svg';
import Dialog from '../../commons/dialog/Dialog';
import Security from '../../commons/security/Security.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import ProgramasPreventivosEditarFechaModal from './ProgramasPreventivosEditarFechaModal.jsx';
import ProgramasPreventivosExclusionModal from './ProgramasPreventivosExclusionModal.jsx';

const PAGINATION_INIT = { page: 0, perPage: 10 };
const FILTROS_INIT = { region: '', estado: '', alerta: '' };
const SORT_INIT = { column: '', direction: '' };

const INDICADOR_CONFIG = {
    ODOMETRO_DESACTUALIZADO:  { labelId: 'programasPreventivosGrilla.indicador_odometro_desactualizado', defaultMessage: 'Odómetro desactualizado', severidad: 'alerta' },
    SIN_PROMEDIO_USO:         { labelId: 'programasPreventivosGrilla.indicador_sin_promedio_uso',         defaultMessage: 'Sin promedio de uso',      severidad: 'alerta' },
    PREVENTIVO_RECIENTE:      { labelId: 'programasPreventivosGrilla.indicador_preventivo_reciente',      defaultMessage: 'Preventivo reciente',      severidad: 'alerta' },
    SIN_HISTORIAL_PREVENTIVO: { labelId: 'programasPreventivosGrilla.indicador_sin_historial_preventivo', defaultMessage: 'Sin historial de preventivo', severidad: 'alerta' },
    SIN_KM_ACTUAL:            { labelId: 'programasPreventivosGrilla.indicador_sin_km_actual',            defaultMessage: 'Sin kilometraje cargado',  severidad: 'alerta' },
    ODOMETRO_INCOHERENTE:     { labelId: 'programasPreventivosGrilla.indicador_odometro_incoherente',     defaultMessage: 'Odómetro incoherente',     severidad: 'critico' },
    TICKET_ABIERTO:           { labelId: 'programasPreventivos.indicador.ticket_abierto',                 defaultMessage: 'Ya tiene un ticket de mantenimiento abierto: no se le va a generar uno automático hasta que se resuelva', severidad: 'alerta' },
};

const PRIORIDAD_CONFIG = {
    CRITICO:   { color: '#dc3545', labelId: 'programasPreventivosGrilla.prioridad_critico',   defaultMessage: 'Crítico' },
    ALERTA:    { color: '#f8a038', labelId: 'programasPreventivosGrilla.prioridad_alerta',     defaultMessage: 'Alerta' },
    NORMAL:    { color: '#28a745', labelId: 'programasPreventivosGrilla.prioridad_normal',     defaultMessage: 'Normal' },
    SIN_DATOS: { color: '#6c757d', labelId: 'programasPreventivosGrilla.prioridad_sin_datos',  defaultMessage: 'Sin datos' },
};

const prioridadConfigDe = (prioridad) => PRIORIDAD_CONFIG[prioridad] || PRIORIDAD_CONFIG.SIN_DATOS;

/**
 * Grilla paginada de vehículos ya generada para un tipo del programa (VEC-3331/VEC-3332).
 * Se refetchea cuando cambia `tipoId`, `refreshToken` (bump tras generar/regenerar), filtros,
 * orden o página.
 */
const ProgramasPreventivosGrillaVehiculos = (props) => {
    const intl = useIntl();
    const tipoId = props.tipoId;
    // previewTipoInput ({ modelo_tipo_id, reglas }): modo preview del wizard (paso 4), antes de
    // guardar — pega a /preview-grilla en vez de a la grilla ya persistida. El caller tiene que
    // memoizar este objeto (useMemo) para no disparar un refetch en cada render.
    const previewTipoInput = props.previewTipoInput;
    const modoPreview = !!previewTipoInput;
    // En preview, excluir/reincluir es opcional: solo se habilita si el caller (wizard) pasa estos
    // callbacks — ProgramasPreventivosAbm los provee para llevar el tracking local de exclusiones
    // marcadas antes de guardar (VEC-3333/VEC-3334 extendido al paso 4).
    const exclusionesPreview = props.exclusionesPreview || {};
    const edicionesFechaPreview = props.edicionesFechaPreview || {};
    const periodoOperativo = props.periodoOperativo;
    const mostrarAcciones = !modoPreview || !!props.onExcluirPreview;

    const [loading, setLoading] = useState(false);
    const [vehiculos, setVehiculos] = useState([]);
    const [paginationCount, setPaginationCount] = useState(0);
    const [pagination, setPagination] = useState({ ...PAGINATION_INIT });
    const [ordenadoPor, setOrdenadoPor] = useState([]);
    const [resumen, setResumen] = useState(null);
    const [filtros, setFiltros] = useState({ ...FILTROS_INIT });
    const [sortQuery, setSortQuery] = useState({ ...SORT_INIT });
    const [regiones, setRegiones] = useState([]);
    const [actionRefresh, setActionRefresh] = useState(0);
    const [vehiculoAExcluir, setVehiculoAExcluir] = useState(null);
    const [vehiculoAEditarFecha, setVehiculoAEditarFecha] = useState(null);

    useEffect(() => {
        Utils.getData('/regiones/select')
            .then(function(data) { setRegiones(data || []); })
            .catch(function() { setRegiones([]); });
    }, []);

    useEffect(() => {
        if (!tipoId && !previewTipoInput) return;
        setPagination({ ...PAGINATION_INIT });
        setFiltros({ ...FILTROS_INIT });
        setSortQuery({ ...SORT_INIT });
    }, [tipoId, previewTipoInput, props.refreshToken]);

    useEffect(() => {
        if (!tipoId && !previewTipoInput) return;
        setLoading(true);

        var promesa;
        if (previewTipoInput) {
            var body = { tipo: previewTipoInput, page: pagination.page, perPage: pagination.perPage };
            if (filtros.region) body.region = filtros.region;
            if (filtros.alerta) body.alerta = filtros.alerta;
            if (filtros.search) body.search = filtros.search;
            if (sortQuery.column) {
                body.sortColumn = sortQuery.column;
                body.sortDirection = sortQuery.direction;
            }
            promesa = Utils.sendDataNoErrorMessage('/programas-preventivos/preview-grilla', 'POST', body);
        } else {
            var q = '?page=' + pagination.page + '&perPage=' + pagination.perPage;
            if (filtros.region) q += '&region=' + encodeURIComponent(filtros.region);
            if (filtros.estado) q += '&estado=' + encodeURIComponent(filtros.estado);
            if (filtros.alerta) q += '&alerta=' + encodeURIComponent(filtros.alerta);
            if (filtros.search) q += '&search=' + encodeURIComponent(filtros.search);
            if (sortQuery.column) q += '&sortColumn=' + sortQuery.column + '&sortDirection=' + sortQuery.direction;
            promesa = Utils.getData('/programa-preventivo-tipos/' + tipoId + '/vehiculos' + q);
        }

        promesa
            .then(function(data) {
                setVehiculos(data.data || []);
                setPaginationCount(data.pagination.count);
                setOrdenadoPor(data.ordenado_por || []);
                setResumen(data.resumen || null);
            })
            .catch(function() {})
            .finally(function() { setLoading(false); });
    }, [tipoId, previewTipoInput, pagination, props.refreshToken, filtros, sortQuery, actionRefresh]);

    const handleFiltroChange = (campo, valor) => {
        setFiltros(function(prev) { return { ...prev, [campo]: valor }; });
        setPagination(function(prev) { return { ...prev, page: 0 }; });
    };

    const requestSort = (column) => {
        setSortQuery(function(prev) {
            if (prev.column !== column) return { column: column, direction: 'asc' };
            if (prev.direction === 'asc') return { column: column, direction: 'desc' };
            return { ...SORT_INIT };
        });
        setPagination(function(prev) { return { ...prev, page: 0 }; });
    };

    const sortIcon = (column) => {
        if (sortQuery.column !== column) return Sort;
        return sortQuery.direction === 'asc' ? SortAsc : SortDesc;
    };

    const labelIndicador = (codigo) => {
        var cfg = INDICADOR_CONFIG[codigo];
        return cfg ? intl.formatMessage({ id: cfg.labelId, defaultMessage: cfg.defaultMessage }) : codigo;
    };

    const colorAlertas = (indicadores) => {
        var hayCritico = (indicadores || []).some(function(cod) {
            return INDICADOR_CONFIG[cod] && INDICADOR_CONFIG[cod].severidad === 'critico';
        });
        return hayCritico ? '#dc3545' : '#f8a038';
    };

    const handleReincluir = (v) => {
        Dialog.confirm(
            intl,
            {
                title: intl.formatMessage({ id: 'programasPreventivosGrilla.reincluir_confirm_titulo', defaultMessage: 'Reincluir unidad' }),
                text: intl.formatMessage({
                    id: 'programasPreventivosGrilla.reincluir_confirm_texto',
                    defaultMessage: '¿Confirmar reincluir esta unidad en el programa?',
                }),
                confirmText: intl.formatMessage({ id: 'programasPreventivosGrilla.reincluir_confirm_boton', defaultMessage: 'Reincluir' }),
            },
            function() {
                if (modoPreview) {
                    props.onReincluirPreview(previewTipoInput.modelo_tipo_id, v.movil_id);
                    return;
                }
                Utils.sendData('/programa-preventivo-tipos/vehiculos/' + v.id + '/reincluir', 'POST', {})
                    .then(function() {
                        setActionRefresh(function(prev) { return prev + 1; });
                        if (props.onVehiculoCambioEstado) props.onVehiculoCambioEstado();
                    })
                    .catch(function() {});
            }
        );
    };

    if (!tipoId && !previewTipoInput) return null;

    // En preview, el backend siempre devuelve estado 'incluida' y la fecha calculada por el sistema
    // (nada se persiste todavía) — superponemos acá el tracking local de exclusiones y ediciones de
    // fecha marcadas antes de guardar.
    var vehiculosMostrados = modoPreview
        ? vehiculos.map(function(v) {
            var overrides = {};
            var ex = exclusionesPreview[v.movil_id];
            if (ex) {
                overrides.estado = 'excluida';
                overrides.motivo_exclusion = ex.motivoNombre;
                overrides.comentario_exclusion = ex.comentario;
            }
            var fechaEditada = edicionesFechaPreview[v.movil_id];
            if (fechaEditada) {
                overrides.fecha_sugerida = fechaEditada;
            }
            return Object.keys(overrides).length > 0 ? Object.assign({}, v, overrides) : v;
        })
        : vehiculos;

    var excluidosPreviewCount = Object.keys(exclusionesPreview).length;
    var resumenMostrado = resumen && modoPreview
        ? Object.assign({}, resumen, {
            incluidos: resumen.total - excluidosPreviewCount,
            excluidos: excluidosPreviewCount,
        })
        : resumen;

    return (
        <React.Fragment>
            {resumenMostrado && (
                <div className="row mb-2">
                    <div className="col-md-3">
                        <div className="text-center p-2" style={{ background: '#f8f9fa', borderRadius: '4px' }}>
                            <h4 className="mb-0">{resumenMostrado.total}</h4>
                            <small className="text-muted"><FormattedMessage id="programasPreventivosGrilla.resumen_total" defaultMessage="Total" /></small>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="text-center p-2" style={{ background: '#f8f9fa', borderRadius: '4px' }}>
                            <h4 className="mb-0" style={{ color: '#28a745' }}>{resumenMostrado.incluidos}</h4>
                            <small className="text-muted"><FormattedMessage id="programasPreventivosGrilla.resumen_incluidos" defaultMessage="Incluidos" /></small>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="text-center p-2" style={{ background: '#f8f9fa', borderRadius: '4px' }}>
                            <h4 className="mb-0" style={{ color: '#dc3545' }}>{resumenMostrado.excluidos}</h4>
                            <small className="text-muted"><FormattedMessage id="programasPreventivosGrilla.resumen_excluidos" defaultMessage="Excluidos" /></small>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="text-center p-2" style={{ background: '#f8f9fa', borderRadius: '4px' }}>
                            <h4 className="mb-0" style={{ color: '#f8a038' }}>{resumenMostrado.con_alertas}</h4>
                            <small className="text-muted"><FormattedMessage id="programasPreventivosGrilla.resumen_con_alertas" defaultMessage="Con alertas" /></small>
                        </div>
                    </div>
                </div>
            )}

            {ordenadoPor.length > 0 && (
                <p className="text-muted mb-2" style={{ fontSize: '13px' }}>
                    <i className="fa fa-sort-amount-asc"></i>{' '}
                    <FormattedMessage id="programasPreventivosGrilla.ordenado_por" defaultMessage="Ordenado por:" />{' '}
                    <strong>{ordenadoPor.join(' → ')}</strong>
                </p>
            )}

            <div className="row mb-2">
                <div className="col-md-3">
                    <select
                        className="form-control form-control-sm"
                        value={filtros.region}
                        onChange={function(e) { handleFiltroChange('region', e.target.value); }}
                    >
                        <option value="">{intl.formatMessage({ id: 'programasPreventivosGrilla.filtro_region_todas', defaultMessage: 'Región: Todas' })}</option>
                        {regiones.map(function(r) {
                            return <option key={r.value} value={r.label}>{r.label}</option>;
                        })}
                    </select>
                </div>
                {!modoPreview && (
                    <div className="col-md-2">
                        <select
                            className="form-control form-control-sm"
                            value={filtros.estado}
                            onChange={function(e) { handleFiltroChange('estado', e.target.value); }}
                        >
                            <option value="">{intl.formatMessage({ id: 'programasPreventivosGrilla.filtro_estado_todos', defaultMessage: 'Estado: Todos' })}</option>
                            <option value="incluida">{intl.formatMessage({ id: 'programasPreventivosGrilla.estado_incluido', defaultMessage: 'Incluido' })}</option>
                            <option value="excluida">{intl.formatMessage({ id: 'programasPreventivosGrilla.estado_excluido', defaultMessage: 'Excluido' })}</option>
                        </select>
                    </div>
                )}
                <div className="col-md-3">
                    <select
                        className="form-control form-control-sm"
                        value={filtros.alerta}
                        onChange={function(e) { handleFiltroChange('alerta', e.target.value); }}
                    >
                        <option value="">{intl.formatMessage({ id: 'programasPreventivosGrilla.filtro_alertas_todas', defaultMessage: 'Alertas: Todas' })}</option>
                        {Object.keys(INDICADOR_CONFIG).map(function(codigo) {
                            return <option key={codigo} value={codigo}>{labelIndicador(codigo)}</option>;
                        })}
                    </select>
                </div>
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder={intl.formatMessage({ id: 'programasPreventivosGrilla.buscar_placeholder', defaultMessage: 'Buscar unidad...' })}
                        value={filtros.search || ''}
                        onChange={function(e) { handleFiltroChange('search', e.target.value); }}
                    />
                </div>
            </div>

            <TableContainer>
                <Table aria-label="programas-preventivos-grilla-vehiculos table" className="table-hover">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="center" style={{ width: '50px' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_prioridad" defaultMessage="Prior." />
                            </StyledTableCell>
                            <StyledTableCell align="left" onClick={function() { requestSort('unidad'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_movil" defaultMessage="Unidad" />
                                <img className="ml-1" src={sortIcon('unidad')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="left" onClick={function() { requestSort('region'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_region" defaultMessage="Región" />
                                <img className="ml-1" src={sortIcon('region')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="right" onClick={function() { requestSort('delta_km'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_delta" defaultMessage="Delta (km)" />
                                <img className="ml-1" src={sortIcon('delta_km')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                <FormattedMessage id="programasPreventivosGrilla.column_costo_correctivos" defaultMessage="Costo correctivos" />
                            </StyledTableCell>
                            <StyledTableCell align="left" onClick={function() { requestSort('anio'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_anio" defaultMessage="Año" />
                                <img className="ml-1" src={sortIcon('anio')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="right" onClick={function() { requestSort('km_actual'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_km_actual" defaultMessage="Km actual" />
                                <img className="ml-1" src={sortIcon('km_actual')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="left" onClick={function() { requestSort('fecha_sugerida'); }} style={{ cursor: 'pointer' }}>
                                <FormattedMessage id="programasPreventivosGrilla.column_fecha_sugerida" defaultMessage="Fecha sug." />
                                <img className="ml-1" src={sortIcon('fecha_sugerida')} alt="sort" style={{ height: '12px', width: '18px' }} />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <FormattedMessage id="programasPreventivosGrilla.column_alertas" defaultMessage="Alertas" />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <FormattedMessage id="programasPreventivosGrilla.column_estado" defaultMessage="Estado" />
                            </StyledTableCell>
                            {mostrarAcciones && (
                                <StyledTableCell align="center" style={{ width: '60px' }}>
                                    <FormattedMessage id="programasPreventivosGrilla.column_acciones" defaultMessage="Acciones" />
                                </StyledTableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <StyledTableCell colSpan={mostrarAcciones ? 11 : 10} align="center" style={{ padding: '40px' }}>
                                    <CircularProgress />
                                </StyledTableCell>
                            </TableRow>
                        ) : vehiculosMostrados.length === 0 ? (
                            <TableRow>
                                <StyledTableCell colSpan={mostrarAcciones ? 11 : 10} align="center" style={{ padding: '40px', color: '#999' }}>
                                    <FormattedMessage
                                        id="programasPreventivosGrilla.empty_state"
                                        defaultMessage="Todavía no se generó la grilla para este tipo de vehículo."
                                    />
                                </StyledTableCell>
                            </TableRow>
                        ) : (
                            vehiculosMostrados.map(function(v) {
                                var prio = prioridadConfigDe(v.prioridad);
                                var indicadores = v.indicadores_riesgo || [];
                                return (
                                    <TableRow key={v.id}>
                                        <StyledTableCell align="center">
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '24px',
                                                    height: '24px',
                                                    lineHeight: '24px',
                                                    borderRadius: '50%',
                                                    backgroundColor: prio.color,
                                                    color: '#fff',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                }}
                                                title={intl.formatMessage({ id: prio.labelId, defaultMessage: prio.defaultMessage })}
                                            >
                                                {v.estado === 'incluida' ? v.orden : '—'}
                                            </span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {v.movil_dominio}{v.movil_unidad ? ' — ' + v.movil_unidad : ''}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {v.region || <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {v.delta_km !== null && v.delta_km !== undefined ? (
                                                <span style={{ color: prio.color, fontWeight: 600 }}>
                                                    {v.delta_km.toLocaleString('es-AR')}
                                                </span>
                                            ) : <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {v.costo_correctivo !== null && v.costo_correctivo !== undefined
                                                ? '$' + v.costo_correctivo.toLocaleString('es-AR')
                                                : <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {v.anio !== null && v.anio !== undefined ? v.anio : <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {v.km_actual !== null && v.km_actual !== undefined
                                                ? v.km_actual.toLocaleString('es-AR')
                                                : <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {v.fecha_sugerida || <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {indicadores.length > 0 ? (
                                                <StyledTooltip
                                                    title={indicadores.map(labelIndicador).join(' · ')}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <i className="fa fa-exclamation-triangle" style={{ color: colorAlertas(indicadores) }}></i>
                                                </StyledTooltip>
                                            ) : <span className="text-muted">—</span>}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {v.estado === 'incluida' ? (
                                                <span className="badge badge-success">
                                                    {intl.formatMessage({ id: 'programasPreventivosGrilla.estado_incluido', defaultMessage: 'Incluido' })}
                                                </span>
                                            ) : (
                                                <StyledTooltip
                                                    title={(v.motivo_exclusion || '') + (v.comentario_exclusion ? ' — ' + v.comentario_exclusion : '')}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <span className="badge badge-danger">
                                                        {intl.formatMessage({ id: 'programasPreventivosGrilla.estado_excluido', defaultMessage: 'Excluido' })}
                                                    </span>
                                                </StyledTooltip>
                                            )}
                                        </StyledTableCell>
                                        {mostrarAcciones && (
                                            <StyledTableCell align="center">
                                                {Security.hasAnyPermission(['PROGRAMAS_PREVENTIVOS_CREAR', 'PROGRAMAS_PREVENTIVOS_EDITAR']) && (
                                                    v.estado === 'incluida' ? (
                                                        <React.Fragment>
                                                            <StyledTooltip
                                                                title={intl.formatMessage({ id: 'programasPreventivosGrilla.accion_editar_fecha', defaultMessage: 'Editar fecha' })}
                                                                arrow
                                                                placement="top"
                                                            >
                                                                <i
                                                                    className="fa fa-calendar mr-2"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={function() { setVehiculoAEditarFecha(v); }}
                                                                ></i>
                                                            </StyledTooltip>
                                                            <StyledTooltip
                                                                title={intl.formatMessage({ id: 'programasPreventivosGrilla.accion_excluir', defaultMessage: 'Excluir' })}
                                                                arrow
                                                                placement="top"
                                                            >
                                                                <i
                                                                    className="fa fa-ban text-danger"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={function() { setVehiculoAExcluir(v); }}
                                                                ></i>
                                                            </StyledTooltip>
                                                        </React.Fragment>
                                                    ) : (
                                                        <StyledTooltip
                                                            title={intl.formatMessage({ id: 'programasPreventivosGrilla.accion_reincluir', defaultMessage: 'Reincluir' })}
                                                            arrow
                                                            placement="top"
                                                        >
                                                            <i
                                                                className="fa fa-undo text-success"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={function() { handleReincluir(v); }}
                                                            ></i>
                                                        </StyledTooltip>
                                                    )
                                                )}
                                            </StyledTableCell>
                                        )}
                                    </TableRow>
                                );
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={paginationCount}
                rowsPerPage={pagination.perPage}
                page={pagination.page}
                onChangePage={function(e, newPage) { setPagination(function(prev) { return { ...prev, page: newPage }; }); }}
                onChangeRowsPerPage={function(e) { setPagination({ page: 0, perPage: parseInt(e.target.value, 10) }); }}
                labelRowsPerPage={intl.formatMessage({
                    id: 'programasPreventivosGrilla.pagination.rows_per_page',
                    defaultMessage: 'Filas por página',
                })}
            />

            <ProgramasPreventivosExclusionModal
                open={!!vehiculoAExcluir}
                vehiculo={vehiculoAExcluir}
                onClose={function() { setVehiculoAExcluir(null); }}
                onConfirmar={function(motivoId, comentario, motivoNombre) {
                    if (modoPreview) {
                        props.onExcluirPreview(previewTipoInput.modelo_tipo_id, vehiculoAExcluir.movil_id, motivoId, comentario, motivoNombre);
                        return Promise.resolve();
                    }
                    return Utils.sendData(
                        '/programa-preventivo-tipos/vehiculos/' + vehiculoAExcluir.id + '/excluir',
                        'POST',
                        { motivo: motivoId, comentario: comentario }
                    ).then(function() {
                        setActionRefresh(function(prev) { return prev + 1; });
                        if (props.onVehiculoCambioEstado) props.onVehiculoCambioEstado();
                    });
                }}
            />

            <ProgramasPreventivosEditarFechaModal
                open={!!vehiculoAEditarFecha}
                vehiculo={vehiculoAEditarFecha}
                periodoOperativo={periodoOperativo}
                onClose={function() { setVehiculoAEditarFecha(null); }}
                onConfirmar={function(nuevaFecha) {
                    if (modoPreview) {
                        props.onEditarFechaPreview(previewTipoInput.modelo_tipo_id, vehiculoAEditarFecha.movil_id, nuevaFecha);
                        return Promise.resolve();
                    }
                    return Utils.sendData(
                        '/programa-preventivo-tipos/vehiculos/' + vehiculoAEditarFecha.id + '/fecha-sugerida',
                        'POST',
                        { fecha_sugerida: nuevaFecha }
                    ).then(function() { setActionRefresh(function(prev) { return prev + 1; }); });
                }}
            />
        </React.Fragment>
    );
};

export default ProgramasPreventivosGrillaVehiculos;
